import { AxiosInstance } from 'axios';

import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import {
  BankInformation,
  StorePaymentLogsData,
  StorePaymentLogsDetailsData,
  StorePaymentLogsDetailsParams,
  StorePaymentLogsParams,
} from './payment.types';

const getBankInformation = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<BankInformation>>(API_ROUTES.GET_BANK_INFORMATION)).data;
};

export const bankInformationQueries = {
  all: () => ['bank-information'],
  detail: () =>
    queryFactoryOptions<ApiResponse<BankInformation>>({
      queryKey: [...bankInformationQueries.all(), 'detail'],
      queryFn: (client) => getBankInformation(client),
    }),
};

const getStorePaymentLogsData = (client: AxiosInstance) => async (params?: StorePaymentLogsParams) => {
  return (
    await client.get<PaginatedApiResponse<StorePaymentLogsData[]>>(API_ROUTES.GET_STORE_PAYMENT_LOGS, {
      params,
    })
  ).data;
};

const getStorePaymentLogsDetailsData = (client: AxiosInstance) => async (params: StorePaymentLogsDetailsParams) => {
  return (
    await client.get<PaginatedApiResponse<StorePaymentLogsDetailsData[]>>(API_ROUTES.GET_STORE_PAYMENT_LOGS_DETAILS, {
      params,
    })
  ).data;
};

export const paymentLogsQueries = {
  all: () => ['payment-logs'],

  list: (params?: StorePaymentLogsParams) =>
    queryFactoryOptions<PaginatedApiResponse<StorePaymentLogsData[]>>({
      queryKey: [...paymentLogsQueries.all(), 'list', params],
      queryFn: (client) => () => getStorePaymentLogsData(client)(params),
    }),

  details: (params: StorePaymentLogsDetailsParams) =>
    queryFactoryOptions<PaginatedApiResponse<StorePaymentLogsDetailsData[]>>({
      queryKey: [...paymentLogsQueries.all(), 'details', params],
      queryFn: (client) => () => getStorePaymentLogsDetailsData(client)(params),
    }),
};
